import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { EntityCrudActions } from 'actions';
import { BILLBOARD } from 'constants/Entities';
import { getActiveCrud } from 'utils/crud';

import BillboardPreview from './Preview';

const BillboardPreviewGate = memo(() => {
    const dispatch = useDispatch();
    const showPreview = useSelector((state) => state.billboard.crud.showPreview);
    const data = useSelector((state) => {
        const activeCrud = getActiveCrud(state);
        return activeCrud?.entity === BILLBOARD.entity ? activeCrud.data : null;
    });

    const loadingSave = useSelector((state) => {
        const activeCrud = getActiveCrud(state);
        return activeCrud?.entity === BILLBOARD.entity ? !!activeCrud.loadingSave : false;
    });

    const handleSave = useCallback(() => {
        dispatch(EntityCrudActions.save({ entity: BILLBOARD, openDetail: false }));
    }, [dispatch]);

    if (!showPreview || !data) return null;

    return <BillboardPreview data={data} loadingSave={loadingSave} onSave={handleSave} />;
});

BillboardPreviewGate.displayName = 'BillboardPreviewGate';

export default BillboardPreviewGate;
